import React from 'react';

const DEFAULT_FONT_SIZE = '18px';

export default function AppScaleStyleSheet() {
  return (
    <style type="text/css">
      {`
      html {
        font-size: ${DEFAULT_FONT_SIZE};
      }
    `}
    </style>
  );
}
